import React, { useMemo, useRef, useState } from "react";
import { Dialog } from 'primereact/dialog';
import ENV from "../ENV";
import md5 from "md5";
import swal from 'sweetalert';
import $ from 'jquery';

const AddNewBtn = (props) => {

    const loginBtn = async (e, status) => {
        e.preventDefault();
        const { customer_list, loading, login, selected, selecteditem, session_code, ...other } = props.inputvalue;
        // console.log(other)
        // return;
        if (props.inputvalue.customer_name === "" && props.inputvalue.customer_contact === "") {
            return;
        }
        if (props.inputvalue.auth.username === "" && props.inputvalue.auth.password === "") {
            return;
        }

        var userlogin = $.ajax({
            url: ENV.DOMAIN + 'api/customer.php',
            type: "POST",
            data: {
                "userlogin": 1,
                "inputvalue": JSON.stringify({ ...other, "status": status })
            },
            dataType: "json",
            success: function (data) {
                if (data[0].status === "success") {
                    if (status === 'submit') {
                        swal({
                            text: "Successfully Submitted",
                            icon: "success",
                            timer: 1000,
                            button: false,
                        }).then(() => {
                            props.setInputValue(prev => ({
                                ...prev,
                                "info": {
                                    "id_customer": '',
                                    "customer_name": '',
                                    "customer_contact": '',
                                    "customer_address": '',
                                    "contact_person": '',
                                    "email_address": '',
                                    "tin": '',
                                },
                                "auth": {
                                    "username": "",
                                    "password": "",
                                },
                                "customer_list": [],
                                "selected": false,
                                "visible": false
                            }))

                        });
                    } else if (status === 'update') {
                        swal({
                            text: "Successfully Submitted and Updated",
                            icon: "success",
                            timer: 1000,
                            button: false,
                        }).then(() => {
                            props.setInputValue(prev => ({
                                ...prev,
                                "info": {
                                    "id_customer": '',
                                    "customer_name": '',
                                    "customer_contact": '',
                                    "customer_address": '',
                                    "contact_person": '',
                                    "email_address": '',
                                    "tin": '',
                                },
                                "auth": {
                                    "username": "",
                                    "password": "",
                                },
                                "customer_list": [],
                                "selected": false,
                                "visible": false
                            }))

                        });
                    } else if (status === 'add_new') {
                        swal({
                            text: "Successfully Added",
                            icon: "success",
                            timer: 1000,
                            button: false,
                        }).then(() => {
                            props.setInputValue(prev => ({
                                ...prev,
                                "info": {
                                    "id_customer": '',
                                    "customer_name": '',
                                    "customer_contact": '',
                                    "customer_address": '',
                                    "contact_person": '',
                                    "email_address": '',
                                    "tin": '',
                                },
                                "auth": {
                                    "username": "",
                                    "password": "",
                                },
                                "customer_list": [],
                                "selected": false,
                                "visible": false
                            }))

                        });
                    }
                } else {

                }
                userlogin.abort()
            }
        });
    }

    return (
        <div>
            <Dialog header={<>Confirmation</>} style={{ width: 400 }} visible={props.inputvalue.visible} onHide={() => props.setInputValue(prev => ({ ...prev, "visible": false }))}>
                <form onSubmit={(e) => loginBtn(e, props.status)}>
                    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                        <div>
                            <label>Username</label>
                            <input type="text" onChange={(e) => props.setInputValue(prev => ({ ...prev, "auth": { ...prev.auth, "username": e.target.value } }))} className="form-control" placeholder="" autoComplete="off" />
                        </div>
                        <div>
                            <label>Password</label>
                            <input type="password" onChange={(e) => props.setInputValue(prev => ({ ...prev, "auth": { ...prev.auth, "password": e.target.value } }))} className="form-control" placeholder="" autoComplete="off" />
                        </div>
                        <div>
                            <button type="submit" className="btn btn-primary">Submit</button>
                        </div>
                    </div>
                </form>
            </Dialog>
            <button onClick={() => props.setInputValue(prev => ({ ...prev, "visible": true }))} className={props.className}>{props.label}</button>
        </div>
    )
}

export default AddNewBtn;
